// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3019":"568beced","4316":"568beced","7713":"568beced"}[chunkId] + ".chunk.css";
};